import { useStrings } from "features/i18n/useStrings";
import strings from "./QuestionMessages.strings";

import "./QuestionMessages.less";

import { GuxIcon } from "genesys-spark-components-react";

import { useAppSelector } from "app/hooks";
import {
    selectDidAiScoringQuestionProcessingFail,
    selectDoesAiAnswerHaveLowConfidence,
    selectDoesAiAnswerHaveLowHistoricalAccuracy,
} from "features/scorable/scorableSlice";
import { useContext, ReactNode } from "react";
import { UserModeContext } from "features/qualityForm/common/Contexts";

function Warning({ message }: { message: string }) {
    return (
        <div className="Warning">
            <GuxIcon
                iconName="alert-warning-triangle"
                data-testid="message-icon"
                decorative={true}
            />
            {message}
        </div>
    );
}

// TODO: change icon type to strictly gux-icon after spark upgrade
function Info({ icon, message }: { icon: ReactNode; message: string }) {
    return (
        <div className="Info">
            {icon}
            {message}
        </div>
    );
}

export function QuestionMessages({ questionId }: { questionId: string }) {
    const t = useStrings(strings);
    const { isAdmin } = useContext(UserModeContext);
    const showAiScoringProcessingFailure = useAppSelector(
        (state) =>
            selectDidAiScoringQuestionProcessingFail(state, questionId) &&
            isAdmin
    );
    const showAiScoringLowConfidenceFailure = useAppSelector(
        (state) =>
            (selectDoesAiAnswerHaveLowConfidence(state, questionId) ||
                selectDoesAiAnswerHaveLowHistoricalAccuracy(
                    state,
                    questionId
                )) &&
            isAdmin
    );

    return (
        <div className="QuestionMessages" data-testid="question-messages">
            {showAiScoringProcessingFailure && (
                <Warning message={t.labels.aiScoringProcessingFailure} />
            )}
            {showAiScoringLowConfidenceFailure && (
                <Info
                    icon={
                        <GuxIcon
                            className="stars"
                            data-testid="ai-scoring-stars"
                            iconName="restricted/custom/sparkles-solid"
                            screenreaderText={t.labels.aiScoringIcon}
                        />
                    }
                    message={t.labels.aiScoringLowConfidenceFailure}
                />
            )}
        </div>
    );
}
